import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GeneralAuthentication from "../general/GeneralAuthentication";
import TwoPanesPanel from "../general/TwoPanesPanel";
import MainPane from "../general/MainPane";
import LeftPaneGeneral from "../general/LeftPaneGeneral";
import BackToApplication from "../general/BackToApplication";
import { ReactComponent as Mailicon } from "../logos/common/iconmail.svg";
import { ReactComponent as Callicon } from "../logos/common/callicon.svg";
import { TwoHeading } from "../general/TwoHeading";
import { OrangeButton } from "../general/OrangeButton";
import * as theme from "../theme";
import Loader3Orange from "../general/Loader3Orange";
import { makeStyles } from "@material-ui/core/styles";
import { getPolicyStatusData } from "../store/policyStatus";
import { getStatusApi } from "../store/policyStatus";
import { getScrollResponsesDiv } from "../store/quotes";
import Modal from "react-modal";
import certificate, {
  allCertificateDetails,
  getAllCertificateList,
  allCertificateListStart,
} from "../store/certificate";
import {
  getArrayOfProspectsId,
  getClientDetailsUsingProspectId,
  getGettingMyBinders,
  getGettingMyBindersSuccess,
  getMyBinders,
  getBinderDetails,
  getSelectedBinderDetails,
  getBinderDetailsUsingProspectId,
  getStatus,
  getBrokers,
  getVertical,
  getRowDetailsFromProspectId,
  getFilteredProspectsIdArray,
  searchProspects,
  getSearchedProspectsArray,
  getBinderPolicies,
  getSelectedBinderPolicy,
  getIsLoading,
  getMyBinderList,
} from "../store/mybinder";
import {
  certificateModalOpened,
  getCertificateModalState,
} from "../store/components";
import { singleCertificateDataList } from "../store/certificate";
import FormControl from "@material-ui/core/FormControl";
import NormalText from "../general/NormalText";
import { activateNavigationPage, getLanguageCode } from "../store/components";
import {
  Client_Business_name,
  Client_Contact,
  Client_Email,
  Client_Name,
} from "../store/permanentQues";
import moment from "moment";
import { PossibleNaviationPages } from "./Navigation";
import Typography from "@material-ui/core/Typography";
import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import Select from "react-dropdown-select";
import { getBrokerInformation } from "../store/broker";
import translations from "../utils/translations";

const ViewCertificate = (props) => {
  let heightDivison = {
    backtoapp: "9%",
    quoteresults: "11%",
    tableheader: "75px",
    bottommargin: "4vmin",
    spaceBetweenHeaderContent: "0px",
    responses: "",
  };
  heightDivison.responses = `calc(100% - ${heightDivison.backtoapp} - ${heightDivison.quoteresults} - ${heightDivison.tableheader} - ${heightDivison.bottommargin} - ${heightDivison.spaceBetweenHeaderContent})`;
  const mainContMargin = "5vw";
  const ColoumnWidth = theme.columnWidthCertificateTable;

  const commonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  };

  const borderCommon = {
    borderRight: "1px solid #D8D8D8",
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      activateNavigationPage({ pagecode: PossibleNaviationPages.mypolicies })
    );
  }, [dispatch]);

  const onCertificateModalOpenHandler = () => {
    dispatch(certificateModalOpened());
  };
  const [query, setQuery] = useState("");
  const [brokerFilter, setBrokerFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [verticalFilter, setVerticalFilter] = useState("");
  const [startDateFilter, setStartDateFilter] = useState(null);
  const [endDateFilter, setEndDateFilter] = useState(null);
  const [showBoardView, setBoardViewVisbility] = useState(false);
  const [loader, setLoader] = useState(false);
  const [dataMessage, setDataMessage] = useState("");
  const isLoading = useSelector(getIsLoading);
  const listApiStart = useSelector(allCertificateListStart);
  const allCertificates = useSelector(getAllCertificateList);
  let { information } = useSelector(getBrokerInformation);
  const languagepreference = information.languagepreference;
  const d = new Date();
  useEffect(() => {
    const certificateId = window.location.href.split("=").slice(-1)[0];
    if (certificateId) {
      setLoader(true);
      dispatch(allCertificateDetails(certificateId)).then(() => {
        if (allCertificates.length > 0) {
          setLoader(false);
        } else if (allCertificates.length === 0) {
          setLoader(false);
        }
      });
    }
  }, []);
  return (
    <>
      <div className="mx-5 my-5">
        <MyBindersTableHeader></MyBindersTableHeader>
        {loader ? (
          <div
            style={{
              width: "100%",
              height: heightDivison.responses,
            }}
          >
            <Loader3Orange></Loader3Orange>
          </div>
        ) : null}
        {allCertificates.length === 0 ? (
          <p
            style={{
              textAlign: "center",
              marginTop: "2%",
              color: "grey",
              fontFamily: "sans-serif",
              fontSize: "20px",
            }}
          >
            No certificate data found please create new certificate
          </p>
        ) : null}
        {allCertificates && loader === false ? (
          allCertificates.map((data) => {
            return (
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    height: "60px",
                    maxHeight: 75,
                    borderBottom:
                      "1px solid " + theme.COLORS.tertiary_ligthindigo,
                    borderTop: "1px solid " + theme.COLORS.tertiary_ligthindigo,
                    backgroundColor: "white",
                  }}
                >
                  <div
                    style={{
                      ...commonStyle,
                      width: ColoumnWidth.first,
                      ...borderCommon,
                    }}
                  >
                    <NormalText
                      text={
                        data?.brokerDetails?.firstname
                          ? data?.brokerDetails.firstname
                          : "-"
                      }
                      fontWeight={"normal"}
                      fontSize={15}
                      color="grey"
                    ></NormalText>
                  </div>
                  <div
                    style={{
                      ...commonStyle,
                      width: ColoumnWidth.second,
                      ...borderCommon,
                    }}
                  >
                    <NormalText
                      text={
                        data.updatedAt ? data?.updatedAt?.split("T")[0] : "-"
                      }
                      fontWeight={"normal"}
                      fontSize={15}
                      color="grey"
                    ></NormalText>
                  </div>
                  <div
                    style={{
                      ...commonStyle,
                      width: ColoumnWidth.third,
                      ...borderCommon,
                    }}
                  >
                    <NormalText
                      text={
                        data?.certificateHolderDetails
                          ? data?.certificateHolderDetails.interestname
                          : "-"
                      }
                      fontWeight={"normal"}
                      fontSize={15}
                      color="grey"
                    ></NormalText>
                  </div>
                  <div
                    style={{
                      ...commonStyle,
                      width: ColoumnWidth.forth,
                      ...borderCommon,
                    }}
                  >
                    <NormalText
                      text={
                        data?.policyDetails?.bindernumber
                          ? data?.policyDetails?.bindernumber
                          : "-"
                      }
                      fontWeight={"normal"}
                      fontSize={15}
                      color="grey"
                    ></NormalText>
                  </div>
                  <div
                    style={{
                      ...commonStyle,
                      width: ColoumnWidth.fifth,
                      ...borderCommon,
                    }}
                  >
                    <NormalText
                      text={
                        data?.policyDetails?.expirydate?.split("T")[0] <
                        d.toISOString().split("T")[0]
                          ? "InActive"
                          : "Active"
                      }
                      fontWeight={"normal"}
                      fontSize={15}
                      color={
                        data?.policyDetails?.expirydate?.split("T")[0] <
                        d.toISOString().split("T")[0]
                          ? "#e11b2e"
                          : "#157f2d"
                      }
                    ></NormalText>
                  </div>
                  <div
                    style={{
                      ...commonStyle,
                      width: ColoumnWidth.sixth,
                      ...borderCommon,
                    }}
                  >
                    <OrangeButton
                      text={translations[languagepreference].edit}
                      color={theme.COLORS.primary_navyblue}
                      onClick={() => {
                        onCertificateModalOpenHandler();
                        dispatch(
                          singleCertificateDataList({ data, copyData: 3 })
                        );
                      }}
                    ></OrangeButton>
                  </div>
                  <div
                    style={{
                      ...commonStyle,
                      width: ColoumnWidth.seventh,
                      ...borderCommon,
                    }}
                  >
                    <OrangeButton
                      text={translations[languagepreference].copy}
                      color={theme.COLORS.primary_navyblue}
                      onClick={() => {
                        onCertificateModalOpenHandler();
                        dispatch(
                          singleCertificateDataList({ data, copyData: 1 })
                        );
                      }}
                    ></OrangeButton>
                  </div>
                </div>
              </>
            );
          })
        ) : allCertificates === [] ? (
          <SomethingFailedGettingMyBinders></SomethingFailedGettingMyBinders>
        ) : null}
      </div>
    </>
  );
};

export default ViewCertificate;

const SomethingFailedGettingMyBinders = () => {
  return (
    <div>Something failed getting my certificate, please contact admin.</div>
  );
};
const MyBindersTableHeader = (props) => {
  const ColoumnWidth = theme.columnWidthCertificateTable;
  let { information } = useSelector(getBrokerInformation);
  const languagepreference = information.languagepreference;

  const columnHeadingsQuotes = {
    first: {
      en: "Broker",
      fr: "Courtier",
    },
    second: {
      en: "Date Created",
      fr: "Date de création",
    },
    third: {
      en: "Certificate Holder",
      fr: "Détenteur du certificat",
    },
    forth: {
      en: "Policy / Binder #",
      fr: "Police / Contrat #",
    },
    fifth: {
      en: "Status",
      fr: "Statut",
    },
    sixth: {
      en: "Edit",
      fr: "Modifier",
    },
    seventh: {
      en: "Copy",
      fr: "Copier",
    },
  };

  const CommonStyleColumn = {
    color: "white",
    fontFamily: "GibsonRegular",
    alignSelf: "center",
    borderRight: `1px solid ${theme.COLORS.table_header_border}`,
    height: "100%",
    display: "flex",
    alignItems: "center",
    letterSpacing: 1,
    justifyContent: "center",
    textAlign: "center",
    fontSize: "1.5vmin",
  };
  const BorderRaidus = 8;
  const headingStyle = {
    height: "75px",
    width: "100%",
    backgroundColor: theme.COLORS.secondary_skyblue,
    borderTopLeftRadius: BorderRaidus,
    borderTopRightRadius: BorderRaidus,
    display: "flex",
    flexDirection: "row",
  };

  return (
    <div style={headingStyle}>
      <div style={{ width: ColoumnWidth.first, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.first[languagepreference]}
      </div>
      <div style={{ width: ColoumnWidth.second, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.second[languagepreference]}
      </div>
      <div style={{ width: ColoumnWidth.third, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.third[languagepreference]}
      </div>
      <div style={{ width: ColoumnWidth.forth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.forth[languagepreference]}
      </div>
      <div style={{ width: ColoumnWidth.fifth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.fifth[languagepreference]}
      </div>
      <div style={{ width: ColoumnWidth.sixth, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.sixth[languagepreference]}
      </div>
      <div style={{ width: ColoumnWidth.seventh, ...CommonStyleColumn }}>
        {columnHeadingsQuotes.seventh[languagepreference]}
      </div>
    </div>
  );
};
